import styled from 'styled-components';
import logoImage from '../../../assets/soji_logo.svg';
import { ReactComponent as DashboardIcon } from '../../../assets/dashboard_icon.svg';
// import { ReactComponent as Verification } from '../../../assets/verification.svg';
import { ReactComponent as HomeIcon } from '../../../assets/home_sidebar_icon.svg';
import { ReactComponent as Promotion } from '../../../assets/promotion.svg';
import { ReactComponent as Banknote } from '../../../assets/banknote.svg';
import { ReactComponent as LogoutIcon } from '../../../assets/logout.svg';
import { ReactComponent as AdminIcon } from '../../../assets/people_icon.svg';
import { NavLink, useNavigate } from 'react-router-dom';
import { colors } from '../../../component/colors';
import { setUser } from '../../../store/auth';
import { useAppDispatch } from '../../../store/hooks';

export const SideBar = () => {
  const sideBar = [
    {
      icon: HomeIcon,
      name: 'Home',
      link: '/'
    },
    {
      icon: DashboardIcon,
      name: 'Categories',
      link: '/categories'
    },
    {
      icon: Promotion,
      name: 'Promotions',
      link: '/promotions'
    },
    {
      icon: Banknote,
      name: 'Fees',
      link: '/fees'
    },
    // {
    //   icon: Verification,
    //   name: 'Verification',
    //   link: '/verification'
    // },
    {
      icon: AdminIcon,
      name: 'Admin',
      link: '/admins'
    }
  ];
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const handleLogout = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    dispatch(setUser(null));
    navigate('/', { replace: true });
  };
  return (
    <Container>
      <LinkContainer>
        <LinkWrapper>
          <Logo src={logoImage} />
          {sideBar.map((option) => {
            const Icon = option.icon;
            return (
              <Link key={option.name} to={option.link}>
                <Icon />
                <IconText>{option.name}</IconText>
              </Link>
            );
          })}
        </LinkWrapper>
        <LinkWrapper>
          <Link onClick={handleLogout} to={'/logout'}>
            <LogoutIcon />
            <IconText>Logout</IconText>
          </Link>
        </LinkWrapper>
      </LinkContainer>
    </Container>
  );
};

const Container = styled.aside`
  min-width: 80px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 10px;
  padding-top: 40px;
  margin-right: 20px;
  overflow-y: auto;
  max-height: 944px;
  height: 90%;
`;
const LinkContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  height: inherit;
`;
const LinkWrapper = styled.div``;
const Logo = styled.img`
  width: 40px;
  align-self: center;
  height: auto;
  margin-bottom: 42px;
`;

const Link = styled(NavLink)`
  display: flex;
  flex-direction: column;
  margin-bottom: 23.96px;
  align-items: center;
  text-decoration: none;
  padding: 8px 0px;
  svg {
    fill: ${colors.greyText};
  }
  &.active {
    background: linear-gradient(90deg, #fde9c0 0%, rgba(253, 233, 192, 0) 100%);
    p {
      color: ${colors.sojiOrange};
    }
    svg {
      fill: ${colors.sojiOrange};
    }
  }
  &:hover {
    background: linear-gradient(90deg, #fde9c0 0%, rgba(253, 233, 192, 0) 100%);
  }
`;
const IconText = styled.p`
  color: #c4c4c4;
  font-family: 'DM Sans';
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.15px;
`;
